import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { logCoreUsage } from 'owa-analytics';
import { useCallback } from 'react';
import { useMiniNavigation } from 'mini-navigation/lib/MiniNavigationContext';
import { useNavigate, useSearchParams } from 'mini-react-router-dom';

/**
 * @returns Callback to update the focused/other route based on the selected pivot
 */
export const useUpdateFocusedOtherRoute = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { currentEntry, entries } = useMiniNavigation();
    return useCallback(
        (isFocusedPivotSelected: boolean) => {
            const selectedFilter = isFocusedPivotSelected ? 0 : 1;
            logCoreUsage('FocusedPivotClick', [selectedFilter]);
            /**
             * Handle switch between focused and other view without pushing the same route multiple times.
             * When other is selected we push the other query param to the URL.
             * When focused is selected, we first try to navigate back if the previous route was focused inbox view.
             * Otherwise, we push the focused query param to the URL.
             */
            const newSearchParams = new URLSearchParams(searchParams);
            if (isFocusedPivotSelected) {
                if (entries[currentEntry.index - 1]?.location.pathname.endsWith('/inbox')) {
                    navigate(-1);
                } else {
                    newSearchParams.set('focusedFilter', 'Focused');
                    setSearchParams(newSearchParams, { replace: true });
                }
            } else {
                newSearchParams.set('focusedFilter', 'Other');
                setSearchParams(newSearchParams);
            }
        },
        [currentEntry.index, entries, navigate, searchParams, setSearchParams]
    );
};
